'use client';

import {
  MonoDefault,
  RadioGroup,
  renderHttpBadge,
} from '@terra/ui-design-system';
import { HStack } from '@terra/ui-styled-system';
import {
  getAssetMergeMethod,
  getAssetMergePath,
  type AssetMergeCandidate,
} from '../../utils/asset-merge/asset-merge-selection';

type AssetMergeSurvivorOptionProps = {
  asset: AssetMergeCandidate;
  isSuggested: boolean;
};

export function AssetMergeSurvivorOption({
  asset,
  isSuggested,
}: AssetMergeSurvivorOptionProps) {
  const path = getAssetMergePath(asset);
  const method = getAssetMergeMethod(asset);

  return (
    <RadioGroup.Item value={asset.id} w="full" minW={0}>
      <RadioGroup.ItemControl flexShrink={0} />
      <RadioGroup.ItemText
        flex="1"
        minW={0}
        fontWeight={isSuggested ? 'bold' : undefined}
      >
        <HStack gap="2" alignItems="center" w="full" minW={0}>
          {method ? renderHttpBadge(method) : null}
          <MonoDefault
            wordBreak="break-word"
            fontWeight={isSuggested ? 'bold' : 'normal'}
          >
            {path}
          </MonoDefault>
        </HStack>
      </RadioGroup.ItemText>
      <RadioGroup.ItemHiddenInput />
    </RadioGroup.Item>
  );
}
